<div data-cy="sticky-header-component" id="sticky-header">
  <div class="left">
    <ng-container #containerMainAction></ng-container>
    @if (isShowingContext) {
      <span class="separator"></span>
    }
    <ng-container #containerContextActions></ng-container>
    @if (isShowingContext || isShowingSearch) {
      <span class="separator"></span>
    }
    <ng-container #containerSearchAction></ng-container>
  </div>
  <div class="right">
    <ng-container #containerSubmitAction></ng-container>
  </div>
</div>
